// removed by extract-text-webpack-plugin
module.exports = {"Main":"src-containers-Rooms-__RoomsPage-module___Main"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Rooms/RoomsPage.module.css
// module id = 1235
// module chunks = 1